export const GET_DRIVER_PROFILE_REQUEST = "GET_DRIVER_PROFILE_REQUEST";
export const GET_DRIVER_PROFILE_SUCCESS = "GET_DRIVER_PROFILE_SUCCESS";
export const GET_DRIVER_PROFILE_FAIL = "GET_DRIVER_PROFILE_FAIL";
